import "./Dashboard.style.css";

// React
import { useEffect, useState } from "react";

// React Router Dom
import { useNavigate } from "react-router-dom";

// Axios
import axios from "axios";

// Components
import NavigationBar from "../../../Components/NavigationBar";
import SideBar from "../../../Components/SideBar";

// Function
import formatRupiah from "../../../Function/formatRupiah";

// React Boostrap
import { Form, Placeholder } from "react-bootstrap";

// React Bootstrap Icons
import { CashStack } from "react-bootstrap-icons";

// Chart.js
import { Line } from "react-chartjs-2";
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend } from "chart.js";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const PageDashboardBusiness = () => {
    const navigate = useNavigate();

    const [isPageLoading, setIsPageLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);

    const [accessToken] = useState(localStorage.getItem("accessToken"));
    // const [userData] = useState(JSON.parse(localStorage.getItem("userData")));

    const [financeSearch, setFinanceSearch] = useState(new Date().toISOString().slice(0, 10));
    const [financeData, setFinanceData] = useState([]);
    const [financeType, setFinanceType] = useState("daily");

    useEffect(() => {
        const fetchData = async () => {
            if (!accessToken) return navigate("/");

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/user`).then(() => {}).catch(() => navigate("/"));

            axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
            axios.defaults.headers.common['Accept'] = `application/json`;
            await axios.get(`${process.env.REACT_APP_API_URL}/api/finance/index?search=${new Date().toISOString().slice(0, 10)}`).then((res) => {
                setFinanceData(res.data.data);
            }).catch((err) => {
                if (err.status === 404) setFinanceData(err.response.data);
                else setFinanceData({"message": "Internal Server Error"});
            })

            await setTimeout(() => setIsPageLoading(false), 500);
            return 1;
        }

        fetchData();
    }, [navigate, accessToken]);

    const handleFinanceSearch = async (date, type) => {
        if (isLoading) return 1;

        setFinanceSearch(date);
        setFinanceType(type);
        setIsLoading(true);

        axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
        axios.defaults.headers.common['Accept'] = `application/json`;
        await axios.get(`${process.env.REACT_APP_API_URL}/api/finance/index?search=${date}&type=${type}`).then((res) => {
            setFinanceData(res.data.data);
        }).catch((err) => {
            if (err.status === 404) setFinanceData(err.response.data);
            else setFinanceData({"message": "Internal Server Error"});
        })

        await setIsLoading(false);
        return 1;
    }

    const data = {
        labels: Object.keys(financeData?.daily || financeData?.monthly || {}).map((date) => date.split("-").at(-1)),
        datasets: [
            {
                label: "Pendapatan",
                data: Object.values(financeData?.daily || financeData?.monthly || {}).map((item) => item.total_income + item.total_finance_income),
                borderColor: "rgba(75, 192, 192, 1)",
                backgroundColor: "rgba(75, 192, 192, 0.2)",
                // tension: 0.5,
                fill: true,
            },
            {
                label: "Pengeluaran",
                data: Object.values(financeData?.daily || financeData?.monthly || {}).map((item) => item.total_expense_business),
                borderColor: "rgba(192, 75, 75, 1)",
                backgroundColor: "rgba(192, 75, 75, 0.2)",
                // tension: 0.5,
                fill: true,
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: { display: true, position: "top", align: "end" },
        },
    };

    return (
        <section id="dashboard" className="dashboard">
            {/* Navigation Bar */}
            <NavigationBar />

            <div className="content-wrapper">
                {/* Side Bar */}
                <SideBar />

                <div className="contents">
                    {!isPageLoading ? (
                        <>
                            <main>
                                <div className="row">
                                    <div className="col col-8">
                                        <div className="chart">
                                            <div className="chart-header">
                                                <h5>Overview Keuangan</h5>
                                            </div>
                                            <div className="chart-body">
                                                <Line data={data} options={options} />  
                                            </div>
                                            <div className="chart-footer">
                                                <Form.Select disabled={isLoading} value={financeType} onChange={(e) => handleFinanceSearch(financeSearch, e.target.value)}>
                                                    <option value="daily">Harian</option>
                                                    <option value="monthly">Bulanan</option>
                                                </Form.Select>
                                                <Form.Control type="date" disabled={isLoading} placeholder="Search Finances" value={financeSearch} onChange={(e) => handleFinanceSearch(e.target.value, financeType)} />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col col-4">
                                        <div className="card pendapatan">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon">
                                                    <CashStack size={30} color="#fff" />
                                                </div>
                                                <div className="text">
                                                    <h5>Pendapatan</h5>
                                                </div>
                                            </div>
                                            <h1>{formatRupiah(financeData?.overall?.total_income + financeData?.overall?.total_finance_income || 0)}</h1>
                                        </div>
                                        <div className="card pengeluaran">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon">
                                                    <CashStack size={30} color="#fff" />
                                                </div>
                                                <div className="text">
                                                    <h5>Pengeluaran</h5>
                                                </div>
                                            </div>
                                            <h1>{formatRupiah(financeData?.overall?.total_expense_business || 0)}</h1>
                                        </div>
                                        <div className="card saldo">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon">
                                                    <CashStack size={30} color="#fff" />
                                                </div>
                                                <div className="text">
                                                    <h5>Saldo</h5>
                                                </div>
                                            </div>
                                            <h1>{formatRupiah(financeData?.overall?.total_income + financeData?.overall?.total_finance_income - financeData?.overall?.total_expense_business || 0)}</h1>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </>
                    ) : (
                        <>
                            <main>
                                <div className="row">
                                    <div className="col col-8">
                                        <div className="chart">
                                            <div className="chart-header mb-3">
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "200px", height: "24px" }} />
                                                </Placeholder>
                                            </div>
                                            <div className="chart-body">
                                                <Placeholder animation="glow">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "100%", height: "300px" }} />
                                                </Placeholder>
                                            </div>
                                            <div className="chart-footer">
                                                <Placeholder animation="glow" className="w-100">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "100%", height: "40px" }} />
                                                </Placeholder>
                                                <Placeholder animation="glow" className="w-100">
                                                    <Placeholder style={{ borderRadius: "8px",  width: "100%", height: "40px" }} />
                                                </Placeholder>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col col-4">
                                        <div className="card pendapatan">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon">
                                                    <CashStack size={30} color="#fff" />
                                                </div>
                                                <div className="text">
                                                    <Placeholder animation="glow">
                                                        <Placeholder style={{ borderRadius: "8px",  width: "148px", height: "24px" }} />
                                                    </Placeholder>
                                                </div>
                                            </div>
                                            <Placeholder animation="glow" className="mt-auto">
                                                <Placeholder style={{ borderRadius: "8px",  width: "200px", height: "32px" }} />
                                            </Placeholder>
                                        </div>
                                        <div className="card pengeluaran">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon">
                                                    <CashStack size={30} color="#fff" />
                                                </div>
                                                <div className="text">
                                                    <Placeholder animation="glow">
                                                        <Placeholder style={{ borderRadius: "8px",  width: "148px", height: "24px" }} />
                                                    </Placeholder>
                                                </div>
                                            </div>
                                            <Placeholder animation="glow" className="mt-auto">
                                                <Placeholder style={{ borderRadius: "8px",  width: "200px", height: "32px" }} />
                                            </Placeholder>
                                        </div>
                                        <div className="card saldo">
                                            <div className="d-flex align-items-center gap-3">
                                                <div className="icon">
                                                    <CashStack size={30} color="#fff" />
                                                </div>
                                                <div className="text">
                                                    <Placeholder animation="glow">
                                                        <Placeholder style={{ borderRadius: "8px",  width: "148px", height: "24px" }} />
                                                    </Placeholder>
                                                </div>
                                            </div>
                                            <Placeholder animation="glow" className="mt-auto">
                                                <Placeholder style={{ borderRadius: "8px",  width: "200px", height: "32px" }} />
                                            </Placeholder>
                                        </div>
                                    </div>
                                </div>
                            </main>
                        </>
                    )}
                </div>
            </div>
        </section>
    )
}

export default PageDashboardBusiness